var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c("h2", { staticClass: "mt-7 text-center hidden-sm-and-down" }, [
        _vm._v("Meine Bestellungen"),
      ]),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _vm.lastOrders.length === 0
            ? _c("h3", { staticClass: "myTitle text-center" }, [
                _vm._v("Keine Bestellungen bisher"),
              ])
            : _vm._e(),
          _vm._l(_vm.lastOrders, function (order) {
            return _c(
              "div",
              {
                staticClass: "lastOrder pointer",
                on: {
                  "&click": function ($event) {
                    return _vm.gotoDetails(order)
                  },
                },
              },
              [
                _c("table", { staticClass: "maxw myTable" }, [
                  _c("tr", [
                    _c("td", { staticStyle: { width: "100px" } }, [
                      _vm._v("#" + _vm._s(order.orderNumber)),
                    ]),
                    _c("td", { staticClass: "text-left" }, [
                      _vm._v(
                        _vm._s(_vm._f("dateToString")(order.createdAt)) + " Uhr"
                      ),
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "text-right",
                        staticStyle: { width: "10%" },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm._f("price")(order.paymentInfo.amount))
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div"),
              ]
            )
          }),
          _c("div", { staticClass: "spacer-15" }),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn-df",
                  attrs: { rounded: "", onclick: "window.history.back()" },
                },
                [_vm._v(" Zurück ")]
              ),
              _c(
                "div",
                { staticClass: "pt-6" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-df",
                      attrs: { rounded: "" },
                      on: { click: _vm.updateList },
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-reload")]),
                      _vm._v(" Aktualisieren "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "spacer-25" }),
        ],
        2
      ),
      _c("FixBasket"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }